import { render, staticRenderFns } from "./DefaultPackaging.vue?vue&type=template&id=6c6bf948&"
import script from "./DefaultPackaging.vue?vue&type=script&lang=ts&"
export * from "./DefaultPackaging.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultPackaging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports